import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, List, ListItem, Popover, Slide, Stack, TextField, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPageMessage, setProcessing } from "../../store/ApplicationStore";
import { apiEndpoints, appConfigs } from "../../constants/ApplicationConstants";
import { deleteRequest, getRequest, postRequest } from "../../utils/ApiUtil";
import { pageMessages } from "../../constants/MessageConstants";
import { addGroupToStore, deleteRbacFromStore, editGroupInStore, storeGroups } from "../../store/AdminRBACStore";
import { RbacSerializer } from "../../serializers/RbacSerializer";
import { Delete, Edit, Folder, MoreVert, Refresh, Search } from "@mui/icons-material";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import { List as ListIcon } from "@mui/icons-material";
import { useHandleError } from "../others/ErrorScreen";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DomainGroupingScreen(){
    const { groups } = useSelector(state => state.adminrbac);
    const { adminmenu } = useSelector(state => state.adminmenu);
    const [ showAddGroup, setShowAddGroup ]= useState(false);
    const [ showEditGroup, setShowEditGroup ]= useState(false);
    const [ groupName, setGroupName ] = useState("");
    const [ groupedDomains, setGroupedDomains ] = useState([]);
    const [ groupNameCharCount, setGroupNameCharCount ]= useState(appConfigs.rbacgroupCharCount);
    const [ domainOptions, setDomainOptions ]= useState(adminmenu&&adminmenu.filter((menu)=> menu.parent===""));
    const [ groupSearch, setGroupSearch ] = useState("");
    const [ domainSearch, setDomainSearch ] = useState("");
    const [ groupSelection, setGroupSelection ] = useState(null);
    const [ showDeleteGroup, setShowDeleteGroup ]= useState(false);

    const dispatch= useDispatch();
    const handleError=useHandleError()

    const fetchRbacGroups  = useCallback(async () => {
        try{
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.getRbacGroups);
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                const fetchedGroups= response.data&&response.data.map((group)=>{
                    return RbacSerializer(group)
                }).filter(obj=>obj)
                dispatch(storeGroups(fetchedGroups));
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }     
    },[dispatch,handleError]);

    useEffect(()=>{
        if(!groups){
            fetchRbacGroups();
        }
    },[dispatch, groups, fetchRbacGroups])

    function handleAddGroupToggle(){
        if(showAddGroup){
            setShowAddGroup(false); setGroupName(""); setGroupedDomains([]); setDomainOptions(adminmenu&&adminmenu.filter((menu)=> menu.parent==="")); setGroupNameCharCount(appConfigs.rbacgroupCharCount); setDomainSearch("");
        }else{
            setShowAddGroup(true);
        }
    }
    function handleEditGroupToggle(group){
        if(showEditGroup){
            setGroupSelection(null); setShowEditGroup(false); setGroupName(""); setGroupedDomains([]); setDomainOptions(adminmenu&&adminmenu.filter((menu)=> menu.parent==="")); setGroupNameCharCount(appConfigs.rbacgroupCharCount); setDomainSearch("");
        }else{
            setShowEditGroup(true); setGroupName(group?.name || ''); setGroupedDomains(group?.domains ||[]); setGroupSelection(group);
        }
    }
    function handleDeleteGroupToggle(group){
        if(showDeleteGroup){
            setGroupSelection(null); setShowDeleteGroup(false);
        }else{
            setShowDeleteGroup(true); setGroupSelection(group);
        }
    }
    function updateGroupedDomains(id){
        try{
            const currentIndex = groupedDomains.indexOf(id);
            const newCheckedItems = [...groupedDomains];
            currentIndex === -1 ?  newCheckedItems.push(id) : newCheckedItems.splice(currentIndex, 1);    
            setGroupedDomains(newCheckedItems);
        }catch(err){
            handleError(err)
        }      
    }
    function handleDomainSearch(e){
        const searchString= e.target.value;
        setDomainSearch(searchString);
        if(e.target.value === ""){
            setDomainOptions(adminmenu&&adminmenu.filter((menu)=> menu && menu.parent===""))
        }else{
            setDomainOptions(adminmenu&&adminmenu.filter((menu)=> menu && menu.parent==="" && menu.name.toLowerCase().includes(searchString.toLowerCase())))
        }
    }


    async function handleAddGroupSubmit(){
        try{
            if(groupName.trim() === ""){
                dispatch(setPageMessage({message: pageMessages.rbacNameRequired, type: "error"}));
            }else if(groupedDomains.length === 0){
                dispatch(setPageMessage({message: pageMessages.rbacDomainsRequired, type: "error"}));
            }else{
                dispatch(setProcessing(true));
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.createRbacGroup, {
                    "rbac_name": groupName.trim(),
                    "domains": groupedDomains
                });
                if(response.isError){
                    dispatch(setProcessing(false));
                    setShowAddGroup(false); setGroupName(""); setGroupedDomains([]); setDomainOptions(adminmenu&&adminmenu.filter((menu)=> menu.parent==="")); setGroupNameCharCount(appConfigs.rbacgroupCharCount); setDomainSearch("");
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    const data=RbacSerializer(response.data)
                    if(data)
                        dispatch(addGroupToStore(data));
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    setShowAddGroup(false); setGroupName(""); setGroupedDomains([]); setDomainOptions(adminmenu&&adminmenu.filter((menu)=> menu.parent==="")); setGroupNameCharCount(appConfigs.rbacgroupCharCount); setDomainSearch("");
                    dispatch(setProcessing(false))
                }
            }
        }catch(err){
            handleError(err)
        }

    }
    async function handleEditGroupSubmit(){
        try{
            if(groupName.trim() ==='')
            {
                dispatch(setPageMessage({message: pageMessages.rbacNameRequired, type: "error"}));   
            }
            else if(groupName.trim() === groupSelection.name && groupedDomains === groupSelection.domain){
                dispatch(setPageMessage({message: pageMessages.editRbacNoChange, type: "error"}));
            }else if(groupedDomains.length === 0){
                dispatch(setPageMessage({message: pageMessages.rbacDomainsRequired, type: "error"}));
            }else{
                dispatch(setProcessing(true));
                let request= null;
                if(groupedDomains !== groupSelection.domain && groupName !== groupSelection.name){
                    request= { "rbac_id": groupSelection.id, "rbac_name": groupName.trim(), "domains": groupedDomains }
                }else if(groupedDomains !== groupSelection.domain){
                    request= { "rbac_id": groupSelection.id, "domains": groupedDomains }
                }else if(groupName !== groupSelection.name){
                    request= { "rbac_id": groupSelection.id, "rbac_name": groupName.trim() }
                }else{
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: pageMessages.editRbacNoChange, type: "error"}));
                }
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.editRbacGroup, request);
                if(response.isError){
                    dispatch(setProcessing(false));
                    setGroupSelection(null); setShowEditGroup(false); setGroupName(""); setGroupedDomains([]); setDomainOptions(adminmenu&&adminmenu.filter((menu)=> menu.parent==="")); setGroupNameCharCount(appConfigs.rbacgroupCharCount); setDomainSearch("");
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    dispatch(editGroupInStore(RbacSerializer(response.data)));
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    setGroupSelection(null); setShowEditGroup(false); setGroupName(""); setGroupedDomains([]); setDomainOptions(adminmenu&&adminmenu.filter((menu)=> menu.parent==="")); setGroupNameCharCount(appConfigs.rbacgroupCharCount); setDomainSearch("");
                    dispatch(setProcessing(false))
                }
            }
        }catch(err){
            handleError(err)
        }
    }
    async function handleDeleteGroupSubmit(){
        try{
            dispatch(setProcessing(true));
            const response = await deleteRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.deleteRbacGroup+"/"+groupSelection.id);
            if(response.isError){
                setGroupSelection(null); setShowDeleteGroup(false);
                dispatch(setPageMessage({message: response.message, type: "error"}));
                dispatch(setProcessing(false));
            }else{
                dispatch(deleteRbacFromStore(groupSelection.id));
                dispatch(setPageMessage({message: response.message, type: "success"}));
                setGroupSelection(null); setShowDeleteGroup(false);
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }    
    }

    return(
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={8}>
                    <Box>
                        <Box display='flex'>
                            <ListIcon sx={{marginRight: '1rem',marginTop:'0.2rem'}}/>
                            <Stack direction='row' alignItems='center'>
                            <Box>
                                <Typography variant='h5'>Domain Group Manager</Typography>
                                <Typography sx={{opacity: '0.6'}} variant='subtitle2'>Collection of Domains to a Group.</Typography>
                            </Box>
                            <Refresh onClick={()=>{fetchRbacGroups()}} sx={{marginLeft: '1rem', opacity: 0.6, cursor:'pointer'}} />
                            </Stack>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={2} lg={2}>
                    <FormControl size="small" >
                        <TextField size="small"  sx={{'& .MuiOutlinedInput-root': {paddingLeft: 0}}}  placeholder="Search group" variant="outlined" value={groupSearch} onChange={(e)=>setGroupSearch(e.target.value)} 
                            InputProps={{ startAdornment: ( <InputAdornment > <IconButton disabled><Search /></IconButton></InputAdornment>)}}/>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={2} lg={2}>
                    <Button onClick={()=>{handleAddGroupToggle()}} sx={{ textTransform: 'capitalize',height:'36px'}} color="primary" variant="contained">Create New Group</Button>
                </Grid>
            </Grid>
            <Grid container sx={{marginTop: '1rem'}} spacing={2}>
                {groups&&groups.length>0?
                (groupSearch===""?groups:groups.filter((item)=>item.name.toLowerCase().includes(groupSearch.toLowerCase()))).length>0?
                (groupSearch===""?groups:groups.filter((item)=>item.name.toLowerCase().includes(groupSearch.toLowerCase()))).map((group)=>{
                    return <Grid key={group.id} item xs={12} md={6} lg={4}>
                                <Box>
                                    <Box display='flex' alignItems='center'>
                                        <Folder sx={{marginRight: '1rem', opacity: 0.6}} />
                                        <Typography fontWeight='bold' color='secondary.main'>{group.name}</Typography>
                                        <PopupState variant="popover">
                                            {(popupState) => (
                                            <>
                                                <MoreVert sx={{cursor: 'pointer', margin: 1}} {...bindTrigger(popupState)} />
                                                <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }} >
                                                    <List sx={{p: 2}}>
                                                        <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleEditGroupToggle(group); popupState.close()}}>
                                                            <Box display="flex" alignItems="center">
                                                                <Edit sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                                <Typography>Edit</Typography>
                                                            </Box>
                                                        </ListItem>
                                                        <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleDeleteGroupToggle(group); popupState.close()}}>
                                                            <Box display="flex" alignItems="center">
                                                                <Delete sx={{ marginRight: '1rem', opacity: "0.5" }} />
                                                                <Typography>Delete</Typography>
                                                            </Box>
                                                        </ListItem>
                                                    </List>
                                                </Popover>
                                            </>
                                            )}
                                        </PopupState>
                                    </Box>
                                    <List>
                                        {adminmenu.filter(item => group.domains.indexOf(item.id)>=0).map((obj)=>{
                                            return <ListItem key={obj.id}><Typography sx={{opacity: 0.6, marginLeft: '2rem'}} variant='subtitle2'>{obj.name}</Typography></ListItem>
                                        })}
                                    </List>
                                </Box>
                            </Grid>
                })
                :  <Grid item xs={12}>
                        <Typography align="center">No matching groups with given search criteria.</Typography>
                    </Grid>
                :  <Grid item xs={12}>
                        <Typography align="center">No groups available.</Typography>
                    </Grid>}
            </Grid>
            <Dialog fullWidth open={showAddGroup} TransitionComponent={Transition} keepMounted onClose={()=>handleAddGroupToggle()}>
                <DialogTitle>Create New Group</DialogTitle>
                <DialogContent sx={{paddingBottom:0}}>
                    <Box sx={{marginTop: '0.4rem'}} >
                        <TextField inputProps={{ maxLength: appConfigs.rbacgroupCharCount }} size='small' fullWidth  label="Group Name" variant="outlined" value={groupName} onChange={(e)=>{setGroupName(e.target.value); setGroupNameCharCount(appConfigs.rbacgroupCharCount - e.target.value.length)}} />
                        <Typography variant='caption' color='grey'>{groupNameCharCount !== appConfigs.rbacgroupCharCount ? `${groupNameCharCount} characters remaining.` : `Maximum ${appConfigs.rbacgroupCharCount} characters are allowed.`}</Typography>
                    </Box>
                    <Box sx={{marginTop: '0.5rem'}}>
                        <Typography fontWeight='bold'>Choose Domains from the below list.</Typography>
                        <FormControl size="small" sx={{marginTop: '0.8rem'}}> <TextField size='small' sx={{'& .MuiOutlinedInput-root': {paddingLeft: 0}}} placeholder="Search Domain" variant="outlined" value={domainSearch} onChange={(e)=>handleDomainSearch(e)} InputProps={{ startAdornment: ( <InputAdornment position="start"> <IconButton disabled><Search /></IconButton></InputAdornment>)}}/></FormControl>
                        <Grid sx={{marginTop: '0.7rem'}} container spacing={0}>
                            {domainOptions&&domainOptions.map((domain)=>{
                                return <Grid key={domain.id} item xs={12} md={6}>
                                            <FormControlLabel value={domain.id} control={<Checkbox checked={groupedDomains.includes(domain.id)} onChange={() => updateGroupedDomains(domain.id)} />} label={<Typography sx={{ wordBreak: 'break-word'}}>  {domain.name}</Typography>} />
                                        </Grid>
                            })}
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleAddGroupToggle()}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' disabled={!(groupName.length <= appConfigs.rbacgroupCharCount)} onClick={()=>handleAddGroupSubmit()}>Create Group</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showEditGroup} TransitionComponent={Transition} keepMounted onClose={()=>handleEditGroupToggle()}>
                <DialogTitle>Edit Group</DialogTitle>
                <DialogContent sx={{paddingBottom:0}}>
                    <Box sx={{marginTop: '0.4rem'}}>
                        <TextField inputProps={{ maxLength: appConfigs.rbacgroupCharCount }} size='small' fullWidth  label="Group Name" variant="outlined" value={groupName} onChange={(e)=>{setGroupName(e.target.value); setGroupNameCharCount(appConfigs.rbacgroupCharCount - e.target.value.length)}} />
                        <Typography variant='caption' color='grey'>{groupNameCharCount !== appConfigs.rbacgroupCharCount ? `${groupNameCharCount} characters remaining.` : `Maximum ${appConfigs.rbacgroupCharCount} characters are allowed.`}</Typography>
                    </Box>
                    <Box sx={{marginTop: '0.5rem'}}>
                        <Typography fontWeight='bold'>Choose Domains from the below list.</Typography>
                        <FormControl size="small" sx={{marginTop: '0.8rem'}}> <TextField size='small' sx={{'& .MuiOutlinedInput-root': {paddingLeft: 0}}}  label="Search" variant="outlined" value={domainSearch} onChange={(e)=>handleDomainSearch(e)} InputProps={{ startAdornment: ( <InputAdornment position="start"> <IconButton disabled><Search /></IconButton></InputAdornment>)}}/></FormControl>
                        <Grid sx={{marginTop: '0.7rem'}} container spacing={0}>
                            {domainOptions&&domainOptions.map((domain)=>{
                                return <Grid key={domain.id} item xs={12} md={6}>
                                            <FormControlLabel value={domain.id} control={<Checkbox checked={groupedDomains.includes(domain.id)} onChange={() => updateGroupedDomains(domain.id)} />} label={  <Typography sx={{ wordBreak: 'break-word'}}>  {domain.name}</Typography>} />
                                        </Grid>
                            })}
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleEditGroupToggle()}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' disabled={!(groupName.length <= appConfigs.rbacgroupCharCount)} onClick={()=>handleEditGroupSubmit()}>Edit Group</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showDeleteGroup} TransitionComponent={Transition} keepMounted onClose={()=>handleDeleteGroupToggle()}>
                <DialogTitle>Delete Group</DialogTitle>
                <DialogContent>
                    <Box >
                        <Typography>Are you sure you want to delete this RBAC group, the users associated with this group will not be further able to access this group. Do you want to proceed?</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleDeleteGroupToggle()}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=>handleDeleteGroupSubmit()}>Delete Group</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}